<template>
  <div class="inline-block relative w-5 h-5 align-middle lg:w-4 lg:h-4">
    <img :src="require(`@/assets/icons/editor/${name}.svg`)" :alt="name"/>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true
    }
  }
}
</script>
